import React, { createContext, useEffect, useReducer } from 'react';
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";
import useError from "../../hooks/useError";
import SessionOut from "../../views/sessions/SessionOut";

const initialValue = {
    banners: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_DASHBOARD_DATA': {
            return {
                ...state,
                banner_list: action.payload,
            }
        }
        case 'UPDATE_DASHBOARD_DATA': {
            let banners = state.banner_list.banners.map((b) => {
                return (b.id === action.payload.id ? action.payload : b);
            })
            return {
                ...state,
                banner_list: {banners: banners},
            }
        }
        case 'ADD_DASHBOARD_DATA': {
            let banners = state.banner_list.banners;
            banners.push(action.payload);
            return {
                ...state,
                banner_list: {banners: banners},
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const BannerContext = createContext({
    banner_list: initialValue,
    getBanners: () => {},
    updateBanners: () => {},
    addBanners: () => {},
})

export const BannersProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)
    const { setError } = useError();

    const getBanners = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sales/get_banners', options);

            dispatch({
                type: 'LOAD_DASHBOARD_DATA',
                payload: res.data,
            })
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }

    const updateBanners = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/sales/update_banners', data, options);

            dispatch({
                type: 'UPDATE_DASHBOARD_DATA',
                payload: res.data,
            })

            return res.data;
        } catch (e) {
            if(e?.response?.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e?.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return null;
        }
    }

    const addBanners = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/sales/add_banners', data, options);

            dispatch({
                type: 'ADD_DASHBOARD_DATA',
                payload: res.data,
            })

            return res.data;
        } catch (e) {
            if(e?.response?.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e?.response?.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e?.response?.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return null;
        }
    }

    useEffect(() => {
        getBanners();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    if(state.status === 401){
        return <SessionOut />
    }

    if(state.banner_list === undefined) {
        return <MatxLoading />
    }

    return (
        <BannerContext.Provider
            value={{
                banner_list: state.banner_list,
                getBanners,
                addBanners,
                updateBanners,
            }}
        >
            {children}
        </BannerContext.Provider>
    )
}

export default BannerContext
